<template>
    <div>
        <add-quiz-question :event-id="eventId"></add-quiz-question>
        <table class="table table-borderless table-responsive">
            <thead>
                <tr>
                    <th class="col-md-4">Titolo</th>
                    <th>Risposte</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(question, index) in quizQuestions" :key="`question-${index}`">
                    <td class="col-md-4">
                        <b-input
                            type="text"
                            :value="question.title"
                            @input="updateQuestion(index, { title: $event })"
                        />
                    </td>
                    <td class="col">
                        <b-tags placeholder="Aggiungi risposta..." add-button-text="Aggiungi" :value="getAnswers(question)" @input="updateAnswers(index, $event)"></b-tags>
                    </td>
                    <td class="col-auto">
                        <b-button
                            variant="danger"
                            @click.prevent="deleteQuestion(question.id)">
                            <i :class="{
                                fas: true,
                                'fa-times': deletingQuestionId !== question.id,
                                'fa-circle-notch': deletingQuestionId === question.id,
                                'fa-spin': deletingQuestionId === question.id
                            }"></i>
                        </b-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
import gql from "graphql-tag";
import AddQuizQuestion from "./AddQuizQuestion";

export default {
    name: "QuizTab",
    components: {AddQuizQuestion},
    props: {
        eventId: Number,
    },
    data() {
        return {
            quizQuestions: [],
            deletingQuestionId: null,
        }
    },
    apollo: {
        quizQuestions: {
            query: gql`query GetQuizQuestions($eventId: ID!) {
                quizQuestions(eventId: $eventId) {
                    id,
                    title,
                    answers
                }
            }`,
            variables() {
                return {
                    eventId: this.eventId,
                }
            }
        }
    },
    methods: {
        getAnswers(question) {
            return JSON.parse(question.answers);
        },
        updateAnswers(index, answers) {
            this.updateQuestion(index, { answers: JSON.stringify(answers)})
        },
        updateQuestion(index, options) {
            let question = {
                ...this.quizQuestions[index],
                ...options
            }
            let quizQuestions = this.quizQuestions.slice()
            quizQuestions[index] = question;
            this.quizQuestions = quizQuestions;
        },
        deleteQuestion(questionId) {
            this.deletingQuestionId = questionId

            this.$apollo.mutate({
                mutation: gql`mutation ($questionId: ID!) {
                    deleteQuestion(questionId: $questionId)
                }`,
                variables: {
                    questionId: questionId
                },
                refetchQueries: [
                    'GetQuizQuestions'
                ]
            }).then((data) => {
                this.$bvToast.toast('Domanda elimintata con successo', {
                    title: 'Domanda eliminata',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 2
                })
                this.deletingQuestionId = null;
            }).catch((error) => {
                this.deletingQuestionId = null;
                console.log(error)
            })
        },
        saveQuestions() {
            this.$apollo.mutate({
                mutation: gql`mutation ($questions: [QuizQuestionInput!]!) {
                    updateQuestions(questions: $questions)
                }`,
                variables: {
                    questions: this.quizQuestions
                },
            }).then((data) => {
            }).catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>

<style scoped>

</style>
